import _ from 'lodash';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { fillTemplate } from 'utilities/strings';
import { getElementStylePropertyValue } from 'utilities/domUtils';
import { setTopNavColorDark } from 'features/navigation/header/actions';
import TextField from '@material-ui/core/TextField';
import { LargeTextField } from 'components/Forms';
import PaddedDivider from 'components/PaddedDivider';
import UserForm from 'components/UserForm';
import { PasswordField } from 'components/Forms';
import UserPromo from 'components/UserPromo';
import { palette } from 'theme';
import SwiftypeTags from 'components/SwiftypeTags';

// import TSHIRT_SIZES from 'constants/TshirtSizes';
// import SuperSelect from 'components/SuperSelect';

import { PaddedContainer, PageWrapper, MainWrapper } from './elements';

import {
  endAction,
  getLoginContentStackData,
  createNewUser,
  login,
  logout,
  sendEmailVerificationLink,
  sendPasswordReset,
  setRegistrationAction,
  updateForm,
  resetForm,
  resetPassword
} from 'features/registration/actions';
import {
  getRegistrationActionFromPath,
  getNewLocationFromAction,
  getFinalRedirectLocation
} from 'features/registration/registrationStateMachine';

class Login extends React.PureComponent {
  componentWillMount() {}

  componentDidMount() {
    const { location, setRegistrationAction, user } = this.props;
    console.log(`componentDidMount @ ${location.pathname}`);
    this.props.setTopNavColorDark();
    this.props.getLoginContentStackData();
    this.props.resetForm();
    setRegistrationAction(
      getRegistrationActionFromPath(user.loginStatus, location)
    );
  }

  componentDidUpdate(prevProps) {
    const { location, setRegistrationAction, user } = this.props;
    if (prevProps.user.loginStatus !== user.loginStatus) {
      setRegistrationAction(
        getRegistrationActionFromPath(user.loginStatus, location)
      );
    }
  }

  getByType(data, type) {
    return _.find(data, ['type', type]);
  }

  getText(form_meta_data) {
    const { submit_status, submit_response, user } = this.props;
    var errorMessage = null;
    if (submit_status === 'error') {
      if (
        submit_response.error_code &&
        this.getByType(form_meta_data.error_text, submit_response.error_code)
      ) {
        errorMessage = this.getByType(
          form_meta_data.error_text,
          submit_response.error_code
        ).text;
      } else {
        errorMessage = this.getByType(form_meta_data.error_text, 'default')
          .text;
      }
    }
    // we replace variable placeholders if we have any (in the form "${user.email}"")
    return fillTemplate(errorMessage ? errorMessage : form_meta_data.text, {
      user: user
    });
  }

  getLoginFields(form_meta_data) {
    const { form, updateForm } = this.props;
    return (
      <Grid container spacing={8} direction="row" alignItems="flex-start">
        <Grid item xs={12}>
          <LargeTextField
            autoComplete="username"
            InputLabelProps={{
              shrink: true
            }}
            fullWidth
            margin="normal"
            id="email"
            name="email"
            label={this.getByType(form_meta_data, 'email').label}
            placeholder={this.getByType(form_meta_data, 'email').placeholder}
            helperText={this.getByType(form_meta_data, 'email').helper_text}
            onChange={event =>
              updateForm({ email: _.trimStart(event.target.value) })
            }
            value={form.email}
          />
        </Grid>
        <Grid item xs={12}>
          <PasswordField
            label={this.getByType(form_meta_data, 'password').label}
            placeholder={this.getByType(form_meta_data, 'password').placeholder}
            helperText={this.getByType(form_meta_data, 'password').helper_text}
            show_password={form.show_password}
            value={form.password}
            updateForm={updateForm}
            isNewPassword={false}
            size="large"
          />
        </Grid>
      </Grid>
    );
  }

  getRegistrationFields(form_meta_data) {
    const { form, updateForm } = this.props;
    return (
      <Grid container spacing={24} direction="row" alignItems="flex-start">
        <Grid item xs={12}>
          <TextField
            autoComplete="given-name"
            InputLabelProps={{
              shrink: true
            }}
            fullWidth
            margin="normal"
            id="first-name"
            label={this.getByType(form_meta_data, 'first_name').label}
            placeholder={
              this.getByType(form_meta_data, 'first_name').placeholder
            }
            helperText={
              this.getByType(form_meta_data, 'first_name').helper_text
            }
            onChange={event =>
              updateForm({ first_name: _.trimStart(event.target.value) })
            }
            value={form.first_name}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            autoComplete="family-name"
            InputLabelProps={{
              shrink: true
            }}
            fullWidth
            margin="normal"
            id="last-name"
            label={this.getByType(form_meta_data, 'last_name').label}
            placeholder={
              this.getByType(form_meta_data, 'last_name').placeholder
            }
            helperText={this.getByType(form_meta_data, 'last_name').helper_text}
            onChange={event =>
              updateForm({ last_name: _.trimStart(event.target.value) })
            }
            value={form.last_name}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            autoComplete="organization"
            InputLabelProps={{
              shrink: true
            }}
            fullWidth
            margin="normal"
            id="company_name"
            label={this.getByType(form_meta_data, 'company').label}
            placeholder={this.getByType(form_meta_data, 'company').placeholder}
            helperText={this.getByType(form_meta_data, 'company').helper_text}
            onChange={event =>
              updateForm({ company_name: _.trimStart(event.target.value) })
            }
            value={form.company_name}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            autoComplete="email"
            InputLabelProps={{
              shrink: true
            }}
            fullWidth
            margin="normal"
            id="email"
            label={this.getByType(form_meta_data, 'email').label}
            placeholder={this.getByType(form_meta_data, 'email').placeholder}
            helperText={this.getByType(form_meta_data, 'email').helper_text}
            onChange={event =>
              updateForm({ email: _.trimStart(event.target.value) })
            }
            value={form.email}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <SuperSelect
            data={TSHIRT_SIZES}
            label={this.getByType(form_meta_data, 'shirt_size').label}
            placeholder={this.getByType(form_meta_data, 'shirt_size').placeholder}
            helperText={this.getByType(form_meta_data, 'shirt_size').helper_text}
            id="tshirt_size"
            onChange={value => updateForm({ tshirt_size: value })}
            style={{ minWidth: 246, marginRight: 40 }}
            value={form.tshirt_size}
          />
        </Grid> */}
        <Grid item xs={12}>
          <PasswordField
            label={this.getByType(form_meta_data, 'password').label}
            placeholder={this.getByType(form_meta_data, 'password').placeholder}
            helperText={this.getByType(form_meta_data, 'password').helper_text}
            show_password={form.show_password}
            value={form.password}
            updateForm={updateForm}
            isNewPassword={true}
          />
        </Grid>
      </Grid>
    );
  }

  getSendPasswordResetFields(form_meta_data) {
    const { form, updateForm } = this.props;
    return (
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <LargeTextField
            autoComplete="username"
            InputLabelProps={{
              shrink: true
            }}
            fullWidth
            margin="normal"
            id="email"
            name="email"
            label={this.getByType(form_meta_data, 'email').label}
            placeholder={this.getByType(form_meta_data, 'email').placeholder}
            helperText={this.getByType(form_meta_data, 'email').helper_text}
            onChange={event =>
              updateForm({ email: _.trimStart(event.target.value) })
            }
            value={form.email}
          />
        </Grid>
      </Grid>
    );
  }

  getResetPasswordFields(form_meta_data) {
    const { form, updateForm } = this.props;
    return (
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <PasswordField
            label={this.getByType(form_meta_data, 'password').label}
            placeholder={this.getByType(form_meta_data, 'password').placeholder}
            helperText={this.getByType(form_meta_data, 'password').helper_text}
            show_password={form.show_password}
            value={form.password}
            updateForm={updateForm}
            isNewPassword={true}
            size="large"
          />
        </Grid>
      </Grid>
    );
  }

  getLoginButton(text, style_variant) {
    const { form, login } = this.props;
    return (
      <Fragment>
        <Button
          size="large"
          variant={style_variant}
          color="primary"
          onClick={login.bind(this, form.email, form.password)}
          fullWidth
        >
          {text}
        </Button>
        <PaddedDivider spacing={1.5} />
      </Fragment>
    );
  }

  getRegisterButton(text, style_variant) {
    const { form, createNewUser, submit_status } = this.props;
    var submitIsDisabled =
      submit_status === 'error' ||
      !(
        form.first_name &&
        form.last_name &&
        form.company_name &&
        form.email &&
        form.password
      ); /*&&
        form.tshirt_size*/
    return (
      <Fragment>
        <Button
          size="large"
          variant={style_variant}
          fullWidth
          color="primary"
          disabled={submitIsDisabled}
          onClick={createNewUser.bind(
            this,
            form.first_name,
            form.last_name,
            form.email,
            form.company_name,
            form.tshirt_size,
            form.password
          )}
        >
          {text}
        </Button>
        <PaddedDivider spacing={1.5} />
      </Fragment>
    );
  }

  getResetPasswordButton(text, style_variant) {
    const { form, resetPassword, submit_status } = this.props;
    return (
      <Button
        size="large"
        variant={style_variant}
        color="primary"
        disabled={!form.password || submit_status === 'error'}
        onClick={resetPassword.bind(this, form.password)}
        fullWidth
      >
        {text}
      </Button>
    );
  }

  getLogoutButton(text, style_variant) {
    const { logout } = this.props;
    return (
      <Button
        size="medium"
        color="secondary"
        variant={style_variant}
        onClick={logout.bind(this)}
        fullWidth
      >
        {text}
      </Button>
    );
  }

  getSendPasswordResetButton(text, style_variant) {
    const { form, sendPasswordReset } = this.props;
    const isEnabled =
      form.email ||
      getElementStylePropertyValue('email', 'background-color') !==
        'rgba(0, 0, 0, 0)';
    return (
      <Button
        size="large"
        variant={style_variant}
        onClick={sendPasswordReset.bind(this, form.email)}
        color="primary"
        disabled={!isEnabled}
        fullWidth
      >
        {text}
      </Button>
    );
  }

  getSendEmailVerificationButton(text, style_variant) {
    const { sendEmailVerificationLink } = this.props;
    return (
      <Button
        size="medium"
        color="secondary"
        variant={style_variant}
        onClick={sendEmailVerificationLink.bind(this)}
        fullWidth
      >
        {text}
      </Button>
    );
  }

  getDismissMessageButton(text, style_variant) {
    const { endAction } = this.props;
    return (
      <Button
        size="medium"
        color="secondary"
        variant={style_variant}
        onClick={() => {
          endAction();
        }}
      >
        {text}
      </Button>
    );
  }

  getButtons(form_meta_data) {
    return (
      <Fragment>
        {form_meta_data.buttons.map(button => {
          switch (button.type) {
            case 'login':
              return this.getLoginButton(button.text, button.style_variant);
            case 'logout':
              return this.getLogoutButton(button.text, button.style_variant);
            case 'register':
              return this.getRegisterButton(button.text, button.style_variant);
            case 'reset_password':
              return this.getResetPasswordButton(
                button.text,
                button.style_variant
              );
            case 'send_password_reset':
              return this.getSendPasswordResetButton(
                button.text,
                button.style_variant
              );
            case 'send_email_verification':
              return this.getSendEmailVerificationButton(
                button.text,
                button.style_variant
              );
            case 'dismiss_message':
              return this.getDismissMessageButton(
                button.text,
                button.style_variant
              );
            default:
              return (
                <Button
                  size="medium"
                  color={
                    button.style_variant === 'contained'
                      ? 'primary'
                      : 'secondary'
                  }
                  variant={button.style_variant}
                  href={button.url}
                  fullWidth
                >
                  {button.text}
                </Button>
              );
          }
        })}
      </Fragment>
    );
  }

  getFields(action) {
    const { content_stack } = this.props;
    switch (action) {
      case 'login':
        return this.getLoginFields(
          this.getByType(content_stack.sections, action).fields
        );
      case 'register':
        return this.getRegistrationFields(
          this.getByType(content_stack.sections, action).fields
        );
      case 'send_password_reset':
        return this.getSendPasswordResetFields(
          this.getByType(content_stack.sections, action).fields
        );
      case 'reset_password':
        return this.getResetPasswordFields(
          this.getByType(content_stack.sections, action).fields
        );
      default:
        return null;
    }
  }

  executeAutomatedActions() {
    const { action, logout, submit_status } = this.props;
    if (!submit_status) {
      switch (action) {
        case 'logout':
          logout();
          return true;
        default:
          return false;
      }
    }
    return false;
  }

  render() {
    const {
      action,
      content_stack,
      location,
      submit_status,
      user,
      form
    } = this.props;
    if (this.executeAutomatedActions()) {
      return null;
    }
    const newLocation = getNewLocationFromAction(action, location);
    if (newLocation) {
      console.log(`redirecting to ${JSON.stringify(newLocation)}`);
      return <Redirect to={newLocation} />;
    }
    const finalRedirectLocation = getFinalRedirectLocation(
      user.loginStatus,
      action,
      submit_status,
      location
    );
    if (finalRedirectLocation) {
      if (finalRedirectLocation.pathname.startsWith('http')) {
        window.location.href = finalRedirectLocation.pathname;
        return null;
      } else {
        console.log(`redirecting to ${JSON.stringify(finalRedirectLocation)}`);
        return <Redirect to={finalRedirectLocation} />;
      }
    }
    if (action && this.getByType(content_stack.sections, action)) {
      const form_meta_data = this.getByType(content_stack.sections, action);
      const showPromo = _.includes(['login', 'register'], action);
      return (
        <MainWrapper>
          <SwiftypeTags
            title={form_meta_data.title}
            excerpt={this.getText(form_meta_data)}
          />

          <PageWrapper
            backgroundImage={
              content_stack.global.background_image &&
              content_stack.global.background_image.url
            }
            wrapperWidth={showPromo ? '60%' : '100%'}
          >
            <PaddedContainer id="login-form">
              <Typography variant="h3" align="center" gutterBottom>
                {form_meta_data.title}
              </Typography>
              <Grid container justify="center">
                <Grid item lg={6} md={7} sm={8}>
                  <UserForm
                    text={this.getText(form_meta_data)}
                    isError={submit_status === 'error'}
                    errorHeading={content_stack.global.error_heading}
                    buttons={this.getButtons(form_meta_data)}
                    fields={this.getFields(action)}
                    action={action}
                    form={form}
                  />
                </Grid>
              </Grid>
            </PaddedContainer>
          </PageWrapper>
          {showPromo && (
            <PageWrapper wrapperWidth="40%" backgroundColor={palette.grey[50]}>
              <UserPromo />
            </PageWrapper>
          )}
        </MainWrapper>
      );
    } else {
      return null;
    }
  }
}

export default withRouter(
  connect(
    state => ({
      action: state.registration.action,
      cart: state.cart,
      content_stack: state.registration.content_stack.login,
      form: state.registration.form,
      loading: state.registration.loading,
      submit_status: state.registration.submit_status,
      submit_response: state.registration.submit_response,
      user: state.buckaneer.user
    }),
    {
      createNewUser,
      endAction,
      login,
      logout,
      setTopNavColorDark,
      getLoginContentStackData,
      resetForm,
      resetPassword,
      sendEmailVerificationLink,
      setRegistrationAction,
      sendPasswordReset,
      updateForm
    }
  )(Login)
);
